import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Button, Select, Input, Tag, Table, Spin} from 'antd';
import {
    getNewRequestPermission,
    getNewRequestPermissionHistory,
    setNewRequestPermission
} from '../../reducers/initReducer';
import "./NewApplications.scss";

import Title from '../../components/Title/Title';
import moment from "moment/moment";

class NewApplicationStatus extends Component {
    state = {
        currentFilter: null,
        currentPage: 1
    };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, value) => {
      if (!err) {
          value.Allow = !this.props.new_request_permission
          this.props.dispatch(setNewRequestPermission(value.Allow, value.changeReason));
      }
    })
  };

  componentDidMount() {
      this.props.dispatch(getNewRequestPermission());
      this.props.dispatch(getNewRequestPermissionHistory());
  }

    componentDidUpdate(prevProps) {
        if (prevProps.new_request_permission !== this.props.new_request_permission) {
            this.setState({
                currentPage: 1,
                currentFilter: null
            }, () => {
                this.props.dispatch(getNewRequestPermissionHistory(1));
                this.props.form.resetFields(['changeReason']);
            });
        }
    }

    handleTableChange = (pagination, filters, sorter, extra) => {
        const nextPage = pagination.current;
        const nextFilter = (filters?.activate && filters.activate.length > 0)
            ? filters.activate[0]
            : null;
        const isPageChanged = nextPage !== this.state.currentPage;
        const isFilterChanged = nextFilter !== this.state.currentFilter;

        if (isPageChanged || isFilterChanged) {
            if (extra && extra.action === 'sort') return;
            this.props.dispatch(
                getNewRequestPermissionHistory(nextPage, nextFilter)
            );
            this.setState({
                currentPage: nextPage,
                currentFilter: nextFilter
            });
        }
    };

    render() {
    const { getFieldDecorator } = this.props.form;
    const {new_request_permission} = this.props;
    const history_list = this.props.history_list;
    const data = [];

    const { getFieldValue } = this.props.form;
    const allowValue = getFieldValue('changeReason') || "";
    const charCount = allowValue.length;
    const changeReasonValue = this.props.form.getFieldValue('changeReason') || '';
    const hasErrors = this.props.form.getFieldError('changeReason');

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = moment(dateString);
        return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : "";
    };

    this.columns = [
        {
                title: 'Ամսաթիվ, Ժամ',
                dataIndex: 'changeDate',
                render: (value) => {
                    if (!value) return '-';
                    return formatDate(value);
                },
                sorter: (a, b) => {
                    return new Date(a.changeDate) - new Date(b.changeDate);
                },
        },
        {
                title: 'Կարգավիճակ',
                dataIndex: 'activate',
                filteredValue: this.state.currentFilter === null ? null : [this.state.currentFilter],
                onCell: () => {
                    return {
                        style: {
                            maxWidth: 200,
                            width: 200
                        },
                    };
                },
                render: (isActive) => {
                    // 1. Logic to determine style
                    const style = {
                        color: isActive ? 'rgba(34, 101, 65, 1)' : 'rgba(35, 39, 46, 1)',
                        backgroundColor: isActive ? 'rgba(175, 221, 196, 0.4)' : 'rgba(221, 223, 233, 1)',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        display: 'inline-block',
                        textAlign: 'center',
                        minWidth: '80px'
                    };
                    return (
                        <span style={style}>
                {isActive ? 'Ակտիվ' : 'Պասիվ'}
            </span>
                    );
                },
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
                    const keys = selectedKeys && selectedKeys.length > 0
                        ? selectedKeys
                        : (this.state.currentFilter !== null ? [this.state.currentFilter] : []);
                    return (
                        <div style={{ padding: 8, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <button
                                onClick={() => {
                                    clearFilters();
                                    confirm();
                                }}
                                style={{
                                    background: keys.length === 0 ? '#e6f7ff' : 'transparent',
                                    border: 'none',
                                    textAlign: 'left',
                                    padding: '5px 12px',
                                    cursor: 'pointer'
                                }}
                            >
                                Բոլորը
                            </button>
                            <button
                                onClick={() => {
                                    setSelectedKeys([true]);
                                    confirm();
                                }}
                                style={{
                                    background: keys[0] === true ? '#e6f7ff' : 'transparent',
                                    border: 'none',
                                    textAlign: 'left',
                                    padding: '5px 12px',
                                    cursor: 'pointer'
                                }}
                            >
                                Ակտիվ
                            </button>
                            <button
                                onClick={() => {
                                    setSelectedKeys([false]);
                                    confirm();
                                }}
                                style={{
                                    background: keys[0] === false ? '#e6f7ff' : 'transparent',
                                    border: 'none',
                                    textAlign: 'left',
                                    padding: '5px 12px',
                                    cursor: 'pointer'
                                }}
                            >
                                Պասիվ
                            </button>
                        </div>
                    )
                },
                filterMultiple: false,
        },
        {
                title: 'Մեկնաբանություն',
                dataIndex: 'changeReason',
                onCell: () => {
                    return {
                        style: {
                            maxWidth: 250,
                        },
                    };
                },
        },
    ];

    if (history_list?.newRequestPermissionHistory) {
        history_list.newRequestPermissionHistory.map((element) => {
            data.push({
                "changeDate": element.changeDate,
                "activate": element.activate,
                "changeReason": element.changeReason,
                })
            })
        }

    const paginationParams = {
        pageSize: data.length,
        total: data.length * history_list?.pageCount,
        hideOnSinglePage: true,
        current: this.state.currentPage,
    };

    const isButtonDisabled =
        (new_request_permission && !changeReasonValue.trim()) || // Required but empty
        changeReasonValue.length > 180 ||                        // Too long
        !!hasErrors;

    return (
        <Spin
            spinning={this.props.loading}
        >
      <div className='column col-6' >
        <Title
          text='ՆՈՐ ՀԱՅՏ ԳԵՆԵՐԱՑՆԵԼՈՒ ԿԱՐԳԱՎԻՃԱԿԻ ՓՈՓՈԽՈՒԹՅՈՒՆ'
          size='md'
          weight='black'
          className='mb_35'
        />

        <div className='new-application-action-wrapper' >
          <Form
            onSubmit={this.onSubmit}
            className=''
          >
              <Form.Item className="column small-12 large-4 custom-select-badge">
                  {getFieldDecorator('Allow', {
                      initialValue: new_request_permission ? 1 : 0,
                      rules: [{ required: true, message: 'դաշտը լրացված չէ' }],
                  })(
                      <Select
                          open={false}
                          suffixIcon={
                              <div className='custom-badge'>
                                  {new_request_permission ? (
                                      <Tag className="badge-item green">Ակտիվ</Tag>
                                  ) : (
                                      <Tag className="badge-item red">Պասիվ</Tag>
                                  )}
                              </div>
                          }
                      >
                          <Select.Option key={1} value={1}>Կարգավիճակը</Select.Option>
                          <Select.Option key={2} value={0}>Կարգավիճակը</Select.Option>
                      </Select>
                  )}
              </Form.Item>

              <Form.Item
                  label="Փոփոխության պատճառ"
                  className="column small-12 large-4"
                  extra={
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>Առավելագույնը 180 սիմվոլ</span>
                          <span style={{ color: charCount > 180 ? 'red' : 'rgba(0,0,0,0.45)' }}>
                              {charCount} / 180
                          </span>
                      </div>
                  }
              >
                  {getFieldDecorator('changeReason', {
                      initialValue: "",
                      rules: [
                          {
                              required: new_request_permission,
                              message: 'դաշտը լրացված չէ'
                          }
                      ],
                  })(
                      <Input.TextArea
                          maxLength={180}
                          style={{ height: '114px', minHeight: '98px', resize: 'none', fontSize: '12px' }}
                      />
                  )}
              </Form.Item>

            <Form.Item className="column small-12">
              <Button
                className={`btn  center-aligned  ${new_request_permission ? 'btn-grey-custom' : 'btn-green'}`}
                htmlType="submit"
                disabled={isButtonDisabled}
              >
                <span>{new_request_permission ? "պասիվացնել" : "ակտիվացնել"}</span>
              </Button>
            </Form.Item>
          </Form>
        </div>
          <Table pagination={paginationParams} columns={this.columns} dataSource={data} onChange={this.handleTableChange} />
      </div>
        </Spin>
    )
  }
}

function mapStateToProps(state) {
  return {
    loading: state.initReducer.loading,
    new_request_permission: state.initReducer.new_request_permission,
      history_list: state.initReducer.history_list,
  }
}

const NewApplicationStatusContainer = Form.create()(NewApplicationStatus);

export default connect(mapStateToProps)(NewApplicationStatusContainer);